"use client";

import { useRouter } from "next/navigation";
import { ArrowLeft } from "lucide-react";

interface BackButtonProps {
  fallback: string;
  variant?: "text" | "button";
  label?: string;
}

export function BackButton({
  fallback,
  variant = "text",
  label = "Back",
}: BackButtonProps) {
  const router = useRouter();

  const handleClick = () => {
    if (typeof window !== "undefined" && window.history.length > 2) {
      router.back();
    } else {
      router.push(fallback);
    }
  };

  if (variant === "button") {
    return (
      <button
        onClick={handleClick}
        className="inline-flex items-center text-sm font-medium text-muted-foreground hover:text-primary mb-12 transition-colors group appearance-none bg-transparent border-none p-0 cursor-pointer"
      >
        <div className="p-2 rounded-full bg-muted/50 border border-border/50 group-hover:bg-primary/10 group-hover:border-primary/30 group-hover:text-primary transition-all mr-3">
          <ArrowLeft className="w-4 h-4 transition-transform group-hover:-translate-x-0.5" />
        </div>
        {label}
      </button>
    );
  }

  return (
    <button
      onClick={handleClick}
      className="text-muted-foreground hover:text-primary transition-colors flex items-center gap-1 group appearance-none bg-transparent border-none p-0 cursor-pointer font-inherit"
    >
      <ArrowLeft className="w-3 h-3 group-hover:-translate-x-0.5 transition-transform" />{" "}
      {label}
    </button>
  );
}
